import { AuthProvider, useAuth } from './context/AuthContext';
import Auth from './views/Auth';
import Main from './views/Main';
import ResetPasswordPage from './views/ResetPasswordPage';

function Inner() {
  const { user, loading } = useAuth();

  // Detect invite landing — ?event=xxx in the URL
 const inviteEventId = sessionStorage.getItem('inviteEventId');
  const hashParams = new URLSearchParams(window.location.hash.slice(1));
  const authError = hashParams.get('error');
  const isPasswordReset = sessionStorage.getItem('authType') === 'recovery';
  console.log('inviteEventId:', inviteEventId, 'authError:', authError);

  if (loading) return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#FAF7F2'}}>
      <div style={{textAlign:'center'}}>
        <div style={{fontFamily:'Cormorant Garamond,serif',fontSize:28,color:'#2C1A0E',marginBottom:8}}>What can we bring?</div>
        <div style={{color:'#7A6555',fontSize:13}}>Setting the table…</div>
      </div>
    </div>
  );

  if (isPasswordReset) {
    return <ResetPasswordPage />;
  }

  if (authError === 'access_denied') {
    return (
      <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#FAF7F2', padding:20 }}>
        <div style={{ textAlign:'center', maxWidth:400 }}>
          <div style={{ fontSize:48, marginBottom:16 }}>🔗</div>
          <h2 style={{ fontFamily:'Cormorant Garamond,serif', fontSize:28, color:'#2C1A0E', marginBottom:8 }}>
            This invite link has expired
          </h2>
          <p style={{ color:'#7A6555', fontSize:14, lineHeight:1.7, marginBottom:24 }}>
            Invite links expire after 7 days for security. Ask your host to send you a new invite, or sign in if you already have an account.
          </p>
          <button
            style={{ background:'#C4612A', color:'white', border:'none', borderRadius:10, padding:'12px 24px', fontFamily:'Jost,sans-serif', fontSize:14, fontWeight:500, cursor:'pointer' }}
            onClick={() => window.location.href = '/'}>
            Go to sign in
          </button>
        </div>
      </div>
    );
  }

  return user
    ? <Main inviteEventId={inviteEventId} />
    : <Auth />;
}

export default function App() {
  return <AuthProvider><Inner /></AuthProvider>;
}
